export default __webpack_public_path__ + "static/media/others5.16390511.jpg";